(function () {
  'use strict';

  const DEFAULT_REDIRECT_URL = '/pages/year-make-engine-search';

  function initYmmRoot(root) {
    if (root.dataset.ymmInitialized === 'true') return;
    root.dataset.ymmInitialized = 'true';

    let selectedMake = null;
    let selectedYear = null;

    const makeSelect = root.querySelector('[data-ymm-field="make"]');
    const yearSelect = root.querySelector('[data-ymm-field="year"]');
    const engineSelect = root.querySelector('[data-ymm-field="engine"]');
    const bodyStyleSelect = root.querySelector('[data-ymm-field="body-style"]');
    const findProductForm = root.querySelector('[data-ymm-form]');

    if (!makeSelect || !yearSelect || !engineSelect || !bodyStyleSelect || !findProductForm) return;

    const redirectOnSubmit = root.dataset.ymmRedirect !== 'false';
    const redirectUrl = root.dataset.ymmRedirectUrl || DEFAULT_REDIRECT_URL;
    const skipSubmit = findProductForm.hasAttribute('data-ymm-no-submit');

    makeSelect.addEventListener('change', (event) => {
      selectedMake = event.target.value;
      selectedYear = null;
      filterOptionsByMake(selectedMake);
      resetInputs('make');
    });

    yearSelect.addEventListener('change', (event) => {
      selectedYear = event.target.value;
      engineSelect.selectedIndex = 0;
      engineSelect.disabled = true;
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = true;
      filterEngineOptions(selectedMake, selectedYear);
      resetInputs('year');
    });

    engineSelect.addEventListener('change', () => {
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = false;
      resetInputs('engine');
    });

    function filterOptionsByMake(make) {
      if (!make) {
        yearSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        engineSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        return;
      }

      yearSelect.querySelectorAll('option').forEach((option) => {
        if (option.value === '') return;
        const makeCompatible = option.getAttribute('data-make-compatible');
        if (makeCompatible) {
          const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
          option.style.display = compatibleMakes.includes(make) ? '' : 'none';
        } else {
          option.style.display = 'none';
        }
      });

      filterEngineOptions(make, selectedYear);
    }

    function filterEngineOptions(make, year) {
      if (!make) {
        engineSelect.querySelectorAll('option').forEach((option) => {
          option.style.display = '';
        });
        return;
      }

      engineSelect.querySelectorAll('option').forEach((option) => {
        if (option.value === '') return;

        const makeCompatible = option.getAttribute('data-make-compatible');
        const yearCompatible = option.getAttribute('data-year-compatible');

        let isMakeCompatible = false;
        if (makeCompatible) {
          const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
          isMakeCompatible = compatibleMakes.includes(make);
        }

        let isYearCompatible = true;
        if (year && yearCompatible) {
          const compatibleYears = yearCompatible.split(',').map((value) => value.trim());
          isYearCompatible = compatibleYears.includes(year);
        } else if (year && !yearCompatible) {
          isYearCompatible = false;
        }

        if (isMakeCompatible && isYearCompatible) {
          option.style.display = '';
          option.disabled = false;
        } else {
          option.style.display = 'none';
          option.disabled = true;
        }
      });
    }

    function resetInputs(adjusted) {
      if (adjusted === 'make') {
        yearSelect.selectedIndex = 0;
        yearSelect.disabled = false;
        engineSelect.disabled = true;
        engineSelect.selectedIndex = 0;
        bodyStyleSelect.disabled = true;
        bodyStyleSelect.selectedIndex = 0;
      }

      if (adjusted === 'year') {
        engineSelect.disabled = false;
        engineSelect.selectedIndex = 0;
        bodyStyleSelect.disabled = true;
        bodyStyleSelect.selectedIndex = 0;
      }

      if (adjusted === 'engine') {
        bodyStyleSelect.disabled = false;
        bodyStyleSelect.selectedIndex = 0;
      }
    }

    function findEngineOption(make, year, engine) {
      for (const option of engineSelect.querySelectorAll('option')) {
        if (!option.value || option.value !== engine) continue;

        const makeCompatible = option.getAttribute('data-make-compatible');
        const yearCompatible = option.getAttribute('data-year-compatible');

        if (!makeCompatible) continue;

        const compatibleMakes = makeCompatible.split(',').map((value) => value.trim());
        if (!compatibleMakes.includes(make)) continue;

        if (year && yearCompatible) {
          const compatibleYears = yearCompatible.split(',').map((value) => value.trim());
          if (!compatibleYears.includes(year)) continue;
        }

        return option;
      }

      return null;
    }

    function clearForm() {
      selectedMake = null;
      selectedYear = null;
      makeSelect.selectedIndex = 0;
      yearSelect.selectedIndex = 0;
      yearSelect.disabled = true;
      engineSelect.selectedIndex = 0;
      engineSelect.disabled = true;
      bodyStyleSelect.selectedIndex = 0;
      bodyStyleSelect.disabled = true;
      bodyStyleSelect.value = 'all';
      clearFieldErrors();
      filterOptionsByMake(null);
    }

    function clearFieldErrors() {
      [makeSelect, yearSelect, engineSelect, bodyStyleSelect].forEach((select) => {
        select.classList.remove('is-error');
      });
    }

    function populateForm(vehicle) {
      if (!vehicle?.make) {
        clearForm();
        return;
      }

      const yearOption = yearSelect.querySelector(`option[value="${CSS.escape(vehicle.year)}"]`);
      const engineOption = findEngineOption(vehicle.make, vehicle.year, vehicle.engine);
      const bodyOption = bodyStyleSelect.querySelector(
        `option[value="${CSS.escape(vehicle.body || 'all')}"]`
      );

      if (!yearOption || !engineOption || !bodyOption) return;

      makeSelect.value = vehicle.make;
      selectedMake = vehicle.make;
      filterOptionsByMake(selectedMake);
      yearSelect.disabled = false;

      yearSelect.value = vehicle.year;
      selectedYear = vehicle.year;
      filterEngineOptions(selectedMake, selectedYear);
      engineSelect.disabled = false;

      engineSelect.querySelectorAll('option').forEach((option) => {
        option.selected = option === engineOption;
      });
      bodyStyleSelect.disabled = false;
      bodyStyleSelect.value = vehicle.body || 'all';
      clearFieldErrors();
    }

    function isFormMatchingVehicle(vehicle) {
      if (!vehicle?.make) {
        return !makeSelect.value && !yearSelect.value && !engineSelect.value;
      }

      const engineOption = findEngineOption(vehicle.make, vehicle.year, vehicle.engine);
      return (
        makeSelect.value === vehicle.make &&
        yearSelect.value === vehicle.year &&
        engineOption?.selected === true &&
        bodyStyleSelect.value === (vehicle.body || 'all')
      );
    }

    function restoreSavedVehicle() {
      const vehicle = window.DdVehicleStorage?.getSelectedVehicle();
      if (isFormMatchingVehicle(vehicle)) return;

      if (!vehicle?.make) {
        clearForm();
        return;
      }

      populateForm(vehicle);
    }

    root.__ymmPopulate = populateForm;
    root.__ymmClear = clearForm;
    root.__ymmGetValues = getFormValues;

    restoreSavedVehicle();

    window.addEventListener('dd:vehicle-storage-change', restoreSavedVehicle);
    window.addEventListener('storage', (event) => {
      if (event.key === window.DdVehicleStorage?.STORAGE_KEY) {
        restoreSavedVehicle();
      }
    });

    if (skipSubmit) return;

    findProductForm.addEventListener('submit', (event) => {
      event.preventDefault();

      const formData = getFormValues();
      let errors = 0;

      [makeSelect, yearSelect, engineSelect, bodyStyleSelect].forEach((select, index) => {
        const key = ['make', 'year', 'engine', 'bodyStyle'][index];
        if (!formData[key]) {
          select.classList.add('is-error');
          errors += 1;
        } else {
          select.classList.remove('is-error');
        }
      });

      if (errors !== 0) return;

      const vehicleData = {
        make: formData.make,
        year: formData.year,
        engine: formData.engine,
        body: formData.bodyStyle,
      };

      if (window.DdVehicleStorage) {
        window.DdVehicleStorage.addVehicle(vehicleData);
      }

      if (redirectOnSubmit) {
        window.location.href = redirectUrl;
        return;
      }

      window.dispatchEvent(
        new CustomEvent('dd:vehicle-set', {
          detail: vehicleData,
        })
      );
    });

    function getFormValues() {
      return {
        make: makeSelect.value,
        year: yearSelect.value,
        engine: engineSelect.value,
        bodyStyle: bodyStyleSelect.value,
      };
    }
  }

  function initAllYmmRoots() {
    document.querySelectorAll('[data-dd-ymm-root]').forEach(initYmmRoot);
  }

  function getRootElement(root) {
    if (typeof root === 'string') {
      return document.querySelector(root);
    }
    return root;
  }

  function populateRoot(root, vehicle) {
    const element = getRootElement(root);
    if (!element) return;
    if (element.__ymmPopulate) {
      element.__ymmPopulate(vehicle);
      return;
    }
    initYmmRoot(element);
    element.__ymmPopulate?.(vehicle);
  }

  function clearRoot(root) {
    const element = getRootElement(root);
    if (!element) return;
    if (element.__ymmClear) {
      element.__ymmClear();
      return;
    }
    initYmmRoot(element);
    element.__ymmClear?.();
  }

  function getRootValues(root) {
    const element = getRootElement(root);
    if (!element) return null;
    if (element.__ymmGetValues) {
      return element.__ymmGetValues();
    }
    initYmmRoot(element);
    return element.__ymmGetValues?.() || null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllYmmRoots);
  } else {
    initAllYmmRoots();
  }

  window.DdYmmSelection = {
    initAll: initAllYmmRoots,
    populateRoot,
    clearRoot,
    getRootValues,
  };
})();
